module.exports = __webpack_public_path__ + "assets/d4860e50ecb6f6b9d1fed1f5366ecb00.png";